export const passwordRouters = ["ForgotPassword", "ResetPassword", "SetPassword"]

const loginRouters = ["ForgotPassword", "ResetPassword", "SetPassword", "SignInForm", "SignUpForm", "SignUpConfirmationPage"]

export default loginRouters



// WEBPACK FOOTER //
// ./src/settings/loginRouters.js